module.exports = __webpack_public_path__ + "static/img/service1.141d98b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service1.png
// module id = Mda3
// module chunks = 1